// src/redux/slices/permissionSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [
    "/dashboard",
    "/Customers/add",
    "/Customers/kyc",
    "/CustomerSearch",
    "/CustomerReport",
    "/EmployeeAttendance",
    "/LeaveForm",
    "/Holiday",
    "/Banking/OpenAccount",
    "/Banking/VerifyAccount",
    "/Banking/ReportPage",
    "/Banking/FdMisReport",
    "/Banking/SavingAccountReport",
    "/Banking/CloseAccount",
    "/Banking/Calculator",
    "/Banking/MisPayment",
    "/wallet/WalletHistory",
    "/wallet/RequestFund",
    "/transactions/payInstallments",
    "/transactions/CollectionReport",
    "/transactions/PayDueAmount",
    "/Loan/PersonalLoanForm",
    "/Loan/CcLoanForm",
    "/Loan/EmiLoanForm",
    "/loan/LoanKyc",
    "/loan/LoanReport",
    "/loan/DueEmiManagement",
    "/loan/LoanCollectionReport",
    "/loan/closure",
    "/loan/EmiCalculator",
    "/print/LoanLetter",
    "/print/slips",
    "/UpdatePassword",
    "/Contact"
  ]
};

const permissionSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.list = action.payload;
    }
  }
});

export const { setPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
